export const negativeTags = tag => {
  return (
    tag.includes('not') ||
    tag.includes('Receiver will be required') ||
    tag.includes('No')
  );
};
